import currency from 'currency.js'
import moment from 'moment'

const formatStyle1 = {
  precision: 0,
  symbol: ''
}

const formatStyle2 = {
  precision: 0,
  symbol: '$'
}

const formatStyle3 = {
  precision: 2,
  symbol: '$'
}

const formatFields1 = ['units', 'avgSf', 'unitSize', 'averageSf', 'rentableSf', 'avgUnitSize', 'beds']

const formatFields2 = ['avgMarketRentSf', 'unitMarketRent', 'mostRecentSalePrice', 'priceUnit', 'unitEffectiveRent', 'mrPerBed', 'erPerBed']

const formatFields3 = ['avgRentSf', 'mrPerSf', 'priceSf', 'erPerSf']

const formatMappings = [
  {
    fields: formatFields1,
    style: formatStyle1
  },
  {
    fields: formatFields2,
    style: formatStyle2
  },
  {
    fields: formatFields3,
    style: formatStyle3
  }
]

export const usNumberFormat = (number, style) => currency(number, { ...style }).format()

export const formatNumber = (field, value) => {
  let result = value
  if (value === null || value === 'NA') {
    return 'NA'
  }

  if (value === '') {
    return ''
  }
  if (field === 'unitType') {
    result = value && value.trim().replace(/ /g, '')
                                  .toLowerCase()
                                  .replace('bedroom', '')
                                  .replace('bath', '')
  } else if (field === 'occupancyAsOfDate') {
    result = `${value}%`
  } else if (field === 'capRate') {
    result = value && `${value.toFixed(2)}%`
  } else if (field === 'mostRecentSaleDate') {
    result = value && moment(value, 'YYYY-MM-DD').format('MM/DD/YYYY')
  } else {
    const resultStyleObj = formatMappings.find(obj => obj.fields.includes(field))
    if (resultStyleObj) {
      result = usNumberFormat(value, resultStyleObj.style)
    }
  }

  return result
}

export const getCurrentLocaleDate = utcDate => new Date(utcDate)

export const getUtcDateFormat = localeDate => localeDate?.toISOString() || (new Date()).toISOString()
